import React, { HTMLAttributes } from 'react';
import Helmet from 'react-helmet';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import {
  Accordion, AccordionItem, Button, Container, WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphFAQ as Type } from '../../../types/uncinc_profile/paragraphs';

import './styles.scss';
import { Text } from '../../../components';

interface ParagraphFAQProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphFAQ: React.FC<ParagraphFAQProps> = ({ entity }) => {
  const paragraphFAQ = entity.toJS();
  const title = paragraphFAQ.field_title[0]?.value;
  const faqItems = paragraphFAQ.field_faq;
  const paragraphBody = paragraphFAQ.field_body?.[0]?.processed || '';


  const schema = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': window.location.href,
    mainEntity: faqItems.map((faqItem) => ({
      '@type': 'Question',
      name: faqItem.entity.title[0].value,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faqItem.entity.body[0].processed,
      },
    })),
  });

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {schema}
        </script>
      </Helmet>

      <div className="Paragraph ParagraphFAQ">
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <Text
                title={title}
                text={paragraphBody}
              />
              <Accordion>
                {faqItems.map((faqItem) => {
                  const body = faqItem.entity.body[0].processed;
                  const media = faqItem.entity.field_media_item[0];
                  const caption = media?.entity.field_caption[0]?.value;
                  const link = faqItem.entity.field_link[0];
                  const linkTitle = link?.title;
                  const linkUri = link?.alias || link?.uri;

                  return (
                    <AccordionItem
                      key={faqItem.target_id}
                      title={faqItem.entity.title[0].value}
                      iconClassName="icon-chevron-up"
                      content={(
                        <>
                          <WysiwygField html={body} />
                          {media && (
                            <DynamicMediaItem media={media} imageAspectRatio="4_3" caption={caption} />
                          )}
                          {linkTitle && linkUri && (
                            <Button
                              className="Button--textual icon-after icon-arrow-right icon-variant-4"
                              href={linkUri}
                              primary={false}
                            >
                              <span>{linkTitle}</span>
                            </Button>
                          )}
                        </>
                      )}
                    />
                  );
                })}
              </Accordion>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default ParagraphFAQ;
